import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgKey = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-key';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M15.18 2.283a6.06 6.06 0 0 0-3.496 1.487c-1.035.902-1.759 2.22-1.983 3.611-.108.671-.06 1.837.098 2.379l.041.14-3.3 3.3-3.3 3.3v4.26H7.5l3.305-3.305 3.305-3.305.144.048c.482.159 1.685.211 2.365.101 2.165-.348 3.996-1.842 4.746-3.871A6.02 6.02 0 0 0 19.98 4.06c-.497-.496-.913-.808-1.473-1.103a6.1 6.1 0 0 0-3.327-.674m1.28 1.54c1.906.331 3.411 1.845 3.719 3.74a4.56 4.56 0 0 1-3.314 5.153 4.3 4.3 0 0 1-1.852.104q-1.43-.231-2.429-1.18c-1.416-1.342-1.838-3.379-1.069-5.153.507-1.169 1.562-2.126 2.762-2.504a4.7 4.7 0 0 1 2.183-.16m-.211 3.167.011.79h1.48l.011-.79.011-.79h-1.524zm-5.685 4.56c.391.645 1.24 1.493 1.89 1.888l.154.094-2.854 2.854L6.9 19.24H4.76V17.1l2.85-2.85a814 814 0 0 1 2.857-2.85c.003 0 .047.067.097.15"
    })
  }));
});
export default SvgKey;